import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from '../generico/servicio/consume-credenciales.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { SpinnerService } from '../spinner.service';

@Injectable({
  providedIn: 'root'
})
export class ClientesService {

  tipos_id : any;
  json_cliente : any;

  constructor(private cred_serv : ConsumeCredencialesService,
              private msj_serv : MensajeService,
              private spiner : SpinnerService) { }

  /**
   * consulta los tipo de identificacion  para registrar usuario.
   */
  public async obtener_tipos_id(){
    const promesa = this.cred_serv.get('clientes/admincliente/tipo-id').toPromise();

    await promesa.then(
      (data : any)=>{

        this.spiner.spin$.next(false);

        if (data.code > 0 ){
          this.msj_serv.ver_mensaje(data.msg, '', this.msj_serv.TIPO_ERROR);
        }else{
          this.tipos_id = data.data;
        }

      }
    );
  }

  /**
   * Funcion que se encarga de registrar un cliente.
   * @param data_form datos de la formulario para crear el cliente.
   */
  public async registrar_cliente(data_form) {

    const promesa = this.cred_serv.post('clientes/admincliente', data_form).toPromise();

    await promesa.then(
      (data : any)=>{
        this.spiner.spin$.next(false);
        let tipo_mensaje = this.msj_serv.TIPO_OK;

        if(data.code > 0){
          tipo_mensaje = this.msj_serv.TIPO_ERROR;
        }else{
          this.json_cliente = data_form;
          this.json_cliente['id_cliente'] = data.data.id_cliente;
        }

        this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje);
      }
    );
    
  }

  /**
   * Funcion que se encarga de actualizar un cliente.
   * @param data_form datos de la formulario para crear el cliente.
   * @param id_cliente cliente que se actualizara
   */
  public async actualizar_cliente(id_cliente : number, data_form : any){

    this.cred_serv.put('clientes/admincliente/'+id_cliente, data_form)
        .subscribe(
          (data : any ) => {
            this.spiner.spin$.next(false);

            let tipo_mensaje = this.msj_serv.TIPO_OK;
            if(data.code > 0){
              tipo_mensaje = this.msj_serv.TIPO_ERROR
            }

            this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje);


          }
        );

  }
}
